import EModuleIds, { ESubModuleIds } from "enums/ModuleEnum"
import React from "react"
import DemolitionBasicDetails from "./Demolitions"
import LogisticBasicDetails from "./Logistics"
import ProjectBasicDetails from "./Projects"
import SurveyBasicDetails from "./Survey"

const ProjectBasicDetailsWrapper = (props: any) => {
    const { moduleId, subModuleId } = props

    if (moduleId === EModuleIds.LOGISTICS) {
        return <LogisticBasicDetails {...props} />
    }

    if (moduleId === EModuleIds.OPERATIONS && subModuleId === ESubModuleIds.SURVEY) {
        return <SurveyBasicDetails {...props} />
    }

    if (moduleId === EModuleIds.OPERATIONS && subModuleId === ESubModuleIds.DEMOLITION) {
        return <DemolitionBasicDetails {...props} />
    }

    return <ProjectBasicDetails {...props} />
}

export default ProjectBasicDetailsWrapper
